import Keycloak from 'keycloak-js';

const keycloakConfig = {
  url: process.env.VUE_APP_KEYCLOAK_URL,
  realm: process.env.VUE_APP_KEYCLOAK_REALM,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
};

const keycloak = new Keycloak(keycloakConfig);

// Inicialización de Keycloak
export function initKeycloak() {
  return keycloak.init({
    //   onLoad: 'check-sso', // o 'login-required' si querés obligar login
    //   silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    onLoad: 'login-required',
    pkceMethod: 'S256',
    checkLoginIframe: false,
  });
}

export function login(options) {
  return keycloak.login(options);
}

export function logout(options) {
  return keycloak.logout(options);
}

export function getToken() {
  return keycloak.token;
}

export function isAuthenticated() {
  return !!keycloak.authenticated;
}

export async function getAccessToken() {
  // Si no está autenticado, no hay token que devolver
  if (!keycloak.authenticated) {
    return null;
  }

  try {
    // Refresca el token si le quedan menos de 30 segundos
    await keycloak.updateToken(30);
    return keycloak.token;
  } catch (error) {
    // Logueamos y propagamos el error para que axios pueda manejarlo
    // (por ejemplo, mostrando un mensaje o redirigiendo a login)
    // eslint-disable-next-line no-console
    console.error('No fue posible actualizar el token de Keycloak', error);
    throw error;
  }
}

export function getUsername() {
  if (keycloak.tokenParsed && keycloak.tokenParsed.preferred_username) {
    return keycloak.tokenParsed.preferred_username;
  }
  return null;
}

export function getRoles() {
  if (
    keycloak.tokenParsed &&
    keycloak.tokenParsed.realm_access &&
    Array.isArray(keycloak.tokenParsed.realm_access.roles)
  ) {
    return keycloak.tokenParsed.realm_access.roles;
  }
  return [];
}

export default keycloak;
